import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import * as Icon from "react-feather";
import TextareaAutosize from 'react-autosize-textarea';
import Loader from 'react-loader-spinner'
import {DataRegister} from "../../services/DataRegister";

class Chat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            phone: "",
            note: "",
            loading: false,
            success: false,
            show: true
        };
    };

    componentWillMount() {}

    componentDidMount() {}

    _send(){
        if(this.state.email !== "" && this.state.phone !== "" && this.state.note !== ""){
            this.setState({loading: true, success: false, error: false});
            DataRegister.setMessage(this.state.email, this.state.phone, this.state.note).then((response) => {
                setTimeout(() => {
                    this.setState({loading: false, phone: "", note: "", email: "", success: true});
                }, 500);
            }, (error) => {
                this.setState({loading: false, phone: "", note: "", email: ""});
            });
        }else{
            this.setState({success: false, error: true});
        }
    }

    _goInternal(option){
        window.open(option, '_self');
    }

    render() {
        return (
            <div onClick={() => this.setState({show: !this.state.show})} className={Styles.container}>
                {
                    this.state.show &&
                    <img className={Styles.containerIcon} src={require("../../assets/images/chat.png")}/>
                }
                {
                    !this.state.show &&
                    <img className={Styles.containerIcon} src={require("../../assets/images/chat_close.png")}/>
                }
            </div>
        );
    }
}

export default Chat;


// WEBPACK FOOTER //
// ./src/components/chat/component.js